import { useState, useEffect } from 'react';
import "./styles/ToggleSwitch.css"

function ToggleSwitch({ onToggle }) {
  // ดึงค่าสถานะของสวิตช์จาก sessionStorage หากมี
  const savedState = sessionStorage.getItem('toggleSwitchState');
  const [isOn, setIsOn] = useState(savedState ? JSON.parse(savedState) : false);

  // บันทึกสถานะลง sessionStorage เมื่อมีการเปลี่ยนแปลง
  useEffect(() => {
    sessionStorage.setItem('toggleSwitchState', JSON.stringify(isOn));
  }, [isOn]);

  const toggleSwitch = () => {
    const newIsOn = !isOn;
    setIsOn(newIsOn);

    if (newIsOn) {
 
      console.log('ToggleSwitch ถูกเปลี่ยนเป็น true');
    }
  };

  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={isOn} onChange={toggleSwitch} />
      <span className="slider"></span>
    </label>
  );
}

export default ToggleSwitch;
